(() => {
  window.addEventListener("DOMContentLoaded", () => {
    if (!document.querySelector('.btn-header-search-toggle')) {
      return
    }

    document.querySelectorAll('.btn-header-search-toggle').forEach((button) => {
      button.addEventListener('click', () => {
        let form = button.closest('.search').querySelector('.ce_header_search')
        document.querySelector('.ce_header_mobile .navWrapper .meta_navigation').classList.toggle('opensearch')

        if(form.classList.contains('visible')) {
          form.classList.remove('visible')
          form.querySelector('input').blur()
          return
        }

        form.classList.add('visible')
        form.querySelector('input').focus()
      })
    })
  })
}) ()
